import { useQuery } from '@tanstack/react-query';
import { ApiEndpoints } from 'types/api';
import { Geolocation } from 'types/common';

async function fetchGeoLocation(): Promise<Geolocation> {
  const response = await fetch(ApiEndpoints.GEOLOCATION);

  if (!response.ok) {
    return Promise.reject(
      new Error('Webtex Reviews: Cannot fetch geolocation'),
    );
  }

  return await response.json();
}

export function useGeoLocation() {
  const {
    data: geolocation = defaultGeolocation,
    isLoading,
    refetch: getGeoLocation,
  } = useQuery(['geolocation'], fetchGeoLocation, {
    cacheTime: 5 * 60 * 1000,
    onError(error) {
      console.error(error);
    },
  });

  return {
    geolocation,
    isLoading,
    getGeoLocation,
  };
}

const defaultGeolocation: Geolocation = {
  country: '',
  region: '',
  region_code: '',
  client_id: '',
};
